// The Inventory List (owner, 2026-10-04: "editable and flexible") is the
// agent's own list, not the printed pad's fixed checklist. `form_data.inventory`:
//
//   { rooms: [{ name, items: [{ name, qty, brand, cond, note }] }], permit_*: 'with'|'without', remarks }
//
// Rooms and items are free text; these presets only make a phone quick to fill.
// The servers' utils/agreementAttachments.inventoryView prints whatever is here, and
// leaves out empty rooms and unnamed items.

// CID's printed pad, as the starting point: the same rooms and fittings.
const FITTINGS = ['Lighting', 'Fan', 'Air-con'];
export const STANDARD_ROOMS = [
  'Living & Dining', 'Master Bedroom', 'Bedroom 2', 'Bedroom 3', 'Kitchen', 'Bathroom', 'Utility / Store',
];

// What a room is likely to hold — the pad's fittings first, then furniture and
// appliances the pad had no line for.
const SUGGEST = [
  [/living|dining|family|hall/i, [...FITTINGS, 'Sofa', 'TV', 'TV cabinet', 'Dining table & chairs', 'Curtains', 'Shoe cabinet']],
  [/bed|study|maid/i, [...FITTINGS, 'Bed frame', 'Mattress', 'Wardrobe', 'Study table', 'Curtains']],
  [/kitchen/i, ['Lighting', 'Fan', 'Cooker hood', 'Cooker hob', 'Fridge', 'Washing machine', 'Microwave oven', 'Water filter', 'Kitchen cabinet']],
  [/bath|toilet/i, ['Lighting', 'Water heater', 'Washbasin', 'W.C. (sit)', 'Shower / bathtub', 'Mirror cabinet']],
  [/balcony|yard|porch|utility|store/i, ['Lighting', 'Clothes rack', 'Washing machine', 'Dryer', 'Shelving']],
];
export const suggestionsFor = (room) => (SUGGEST.find(([re]) => re.test(room || ''))?.[1]) || [...FITTINGS, 'Curtains'];

export const ROOM_SUGGESTIONS = ['Bedroom 4', 'Study room', 'Balcony', 'Yard', 'Family hall', 'Maid’s room', 'Car porch'];

export const CONDITIONS = ['Good', 'Fair', 'Poor'];

export const PERMITS = [
  ['permit_aircon', 'Air-con installed'],
  ['permit_heater', 'Water heater installed'],
  ['permit_renovation', 'Building renovation work'],
];

export const roomsOf = (inv) => (Array.isArray(inv?.rooms) ? inv.rooms : []);

/** Items that will print — a named item in any room. */
export const listedCount = (inv) => roomsOf(inv)
  .reduce((n, r) => n + (r.items || []).filter((i) => String(i.name || '').trim()).length, 0);
